export default "__VITE_ASSET__cf3e6b1d__"